import type { TrackerEvent } from './tracker.constant';

// Base event function for all tracking purposes
export const trackEvent = (event: TrackerEvent, payload: any) => {
  window.dataLayer.push({
    event,
    ...payload,
  });
};
